import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { CitysPage } from './citys.page';
import { TranslateModule } from '@ngx-translate/core';

const routes: Routes = [
  {
    path: '',
    component: CitysPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes),
  TranslateModule],
  exports: [RouterModule],
})
export class CitysPageRoutingModule {}
